import { Divider, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  callAPI,
  IRoleMain,
  MasterPages,
  Method
} from "../../../commonFunctions/CommonFunctions";
import { getPermissions } from "../../../commonFunctions/PermissionManger";

import { Header } from "../../../Components/Header/Header";
import { useDispatch } from "react-redux";
import WSDataGridForDashboard, {
  IColumns
} from "../../../Components/DataGrid/WSDataGridForDashboard";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent } from "../../../StateManagement/actions";

import { useForm } from "react-hook-form";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";

export const UserList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [customers, setCustomers] = useState([]);
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response: any = await callAPI("User/getAll", Method.GET);
        if (response) {
          console.log("response is", response);
          setCustomers(response);
        }
      } catch (error) {
        console.error("failed to retrieve data", error);
        showMessage("Something went wrong. Please try again.", "error");
      }
    };

    fetchCustomers();
  }, []);

  const handleAction = (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/user/${row?.id}`);
    }
    if (action === "Delete") {
      setSelectedId(row.id); // Set the ID of the row to be deleted
      setPopupOpen(true);
    }
  };

  const handleClick = () => {
    navigate("/user/create");
  };

  const handleDelete = () => {
    dispatch(resetDataComponent("customerList"));
    showMessage("Customer removed successfully!", "success");
  };
 
  const columns: IColumns[] = [
    {
      header: "Customer Name",
      fieldName: "name",
      type: "default"
    },
    {
      header: "Phone Number",
      fieldName: "phoneno",
      type: "default"
    },
    {
      header: "Email",
      fieldName: "email",
      type: "default"
    },
    {
      header: "DOB",
      fieldName: "dob",
      type: "date"
    },
    {
      header: "Anniversary",
      fieldName: "anniversary",
      type: "date"
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];
  return (
    <>
      {" "}
      <Grid item container spacing={2}>
        <Grid item sm={12} xs={12}>
          <Divider />
        </Grid>
      </Grid>
      <Header
        type="simple"
        isDivider={true}
        title="Customers"
        id={"customerListHeader"}
        headerSx={{ marginTop: 0 }}
      />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGridForDashboard
            id="customerList"
            title="Customers"
            columns={columns}
            // filterFields={filterRows}
            // searchBox={{ fieldName: "name,phoneNo" }}
            data={customers}
            addButton={{ label: "New", color: "secondary" }}
            onAddButtonClick={handleClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke"
            }}
          />

          {selectedId !== null && (
            <ConfirmationPopup
              apiUrl={"User"}
              id={selectedId}
              confirmMessage="Are you sure you want to remove this customer?"
              open={isPopupOpen}
              onClose={() => setPopupOpen(false)}
              onConfirm={handleDelete}
              permanent
            />
          )}
        </Grid>
      </Grid>
    </>
  );
});
